
import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ApiGateway, PageOptions, Patient } from 'cw-backend';
import { CwUtils } from 'cw-utils';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class AttendancePatientListProvider implements Resolve<any> {
    patientList: Patient[];
    patientEdit: Patient;
    onDataChanged: BehaviorSubject<any>;
    onHoraryChanged: BehaviorSubject<any>;
    onTypeChanged: BehaviorSubject<any>;
    onPerformerChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
        this.onPerformerChanged = new BehaviorSubject({});
        this.onTypeChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        if (this.state?.currentPage && state.url.includes(this.state?.path)) {
            this.currentPage = this.state?.currentPage;
        }
        this.patientEdit = this.state?.currentPatient;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
        }
        else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = 'person.name';
        }
        return new Promise<void>((resolve, reject) => {
            Promise.all([
                // this.getPage(this.pageOptions)
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    get(id: number): Observable<Patient> {
        if (!id) {
            return null;
        }
        return this.gw.get('patient/:id', { id: id });
    }

    getById(id: number): Observable<HttpResponse<Patient>> {
        if (!id) {
            return null;
        }
        return this.gw.get('patient/wAll/:id', { id: id });
    }

    getSimpleObjById(id: number): Observable<HttpResponse<Patient>> {
        if (!id) {
            return null;
        }

        return this.gw.get('patient/simpleObj/:id', { id: id });
    };

    get currentPatient(): Patient {
        return this.patientEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('patient/').subscribe((res: HttpResponse<any>) => {
                this.patientList = res.body;
                resolve(res);
            }, reject);
        });

    }

    getPage(pageOptions: PageOptions, type: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post(`patient/searchForAttendance/${type}`, pageOptions).subscribe((res: HttpResponse<any>) => {
                if (!CwUtils.compare(this.patientList, res.body.content) && res.body.content.length > 0) {
                    this.patientList = res.body.content;
                    this.onDataChanged.next(this.patientList);
                }
                else {
                    this.patientList = res.body.content;
                };

                resolve(res);
            }, reject);
        });
    }

    getPersonImageListId(personId): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('patient/person/:personId/image/search', { personId: personId }).subscribe((res: HttpResponse<any>) => {
                resolve(res);
            }, reject);
        });

    };

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}


